module.exports = __webpack_public_path__ + "images/common/top_medal_cb2206466754ca7319ae5d7ebc367b89.png";